module.exports = __webpack_public_path__ + "static/media/ascent_hero_rendering_menu.3a782ef6.jpg";